// src/utils/util.js

// Reference: https://www.npmjs.com/package/libphonenumber-js
import parsePhoneNumber from 'libphonenumber-js'
import axios from 'axios'

const headers = {
  'Content-Type': 'application/x-www-form-urlencoded',
  'Access-Control-Allow-Origin': '*'
}

export default {
  headers,

  getDate: function(date, days) {
    if (days) this.setDate(date, days)
    let m = String(date.getMonth() + 101).substring(1, 3)
    let d = String(date.getDate() + 100).substring(1, 3)
    return date.getFullYear() + '-' + m + '-' + d
  },

  setDate: function(date, days) {
    date.setDate(date.getDate() + days);
  },

  getDateOfWeek: function(date, day) {
    return this.getDate(new Date(date.setDate(date.getDate() - date.getDay() + day)))
  },

  getDateOfMonth: function(date, month) {
    return this.getDate(new Date(date.getFullYear(), date.getMonth() + month, month ? 0 : 1))
  },

  getPhoneNumber: function (number) {
    if (!number || number.length < 10) return 'N/A'
    let phoneNumber = parsePhoneNumber(number, 'KR')
    if (phoneNumber)
      return phoneNumber.formatNational()
    return 'N/A'
  },
  
  getItem: function (items, id) {
    let item = items.find(item => item.value === id)
    return item ? item : { value: 0, text: '알 수 없음 (' + id + ')' }
  },

  getStudios: function (callback) {
    axios.get('/api/studio/list')
    .then(response => {
      let items = []
      if (response.data.error)
        callback(items, response.data.error)
      else {
        response.data.list.forEach(item => {
          items.push({
            value: item.id,
            text: item.name,
            link: item.link,
            phone: item.phone,
            address: item.address
          })
        })
        callback(items)
      }
    })
  },

  getLevels: function (callback) {
    axios.get('/api/user/level')
    .then(response => {
      let items = []
      if (response.data.error)
        callback(items, response.data.error)
      else {
        response.data.list.forEach(item => {
          items.push({
            value: item.id,
            text: item.name
          })
        })
        callback(items)
      }
    })
  },

  getLessons: function (studio, callback) {
    axios.get(`/api/lesson/list/${studio}`)
    .then(response => {
      let items = []
      if (response.data.error)
        callback(items, response.data.error)
      else {
        response.data.list.forEach(item => {
          items.push({
            value: item.id,
            text: item.name,
            coupon_type: item.coupon_type,
            coupons: item.count
          })
        })
        items.sort((a, b) => a.text < b.text ? -1 : 1)
        callback(items)
      }
    })
  },

  getCouponTypes: function (callback) {
    axios.get('/api/coupon/type/list')
    .then(response => {
      let items = []
      if (response.data.error)
        callback([], response.data.error)
      else {
        response.data.list.forEach(item => {
          items.push({
            value: item.id,
            text: item.name
          })
        })
        items.sort((a, b) => a.id < b.id ? -1 : 1)
        callback(items)
      }
    })
  },

  getInstructors: function (studio, callback) {
    axios.get(`/api/user/list/${studio}/3/0/100`)
    .then(response => {
      let items = []
      if (response.data.error)
        callback([], response.data.error)
      else {
        response.data.list.forEach(item => {
          items.push({
            value: item.id,
            text: item.name
          })
        })
        items.sort((a, b) => a.text < b.text ? -1 : 1)
        callback(items)
      }
    })
  },

  getUserCoupon: function (id, callback) {
    axios.get(`/api/user/info/${id}`)
    .then(response => {
      if (response.data.error) {
        callback(response.data.error)
      }
      else {
        let info = '없음'
        if (response.data.info.coupon) {
          let array = response.data.info.coupon.split('/')
          let remain = Number(array[1])
          let days = Number(array[2])
          if (remain > 0 && days >= 0) {
            let date = this.getDate(new Date, days)
            info = `${remain}개 (~ ${date})`
          }
        }
        callback(info)
      }
    })
  }
}

// End of util.js